import { ErrorMessage } from '@as-react/common-types';
import { isPossiblePhoneNumber } from '@yonderland/andes-react';
import * as Yup from 'yup';
import { mapWithAssert } from '../../../util/ArrayUtil';
import { generateFieldName } from '../address-fields/addressFields.utils';
export var CustomerDetailsFieldName;
(function (CustomerDetailsFieldName) {
    CustomerDetailsFieldName["ID_TITLE"] = "idTitle";
    CustomerDetailsFieldName["MIDDLE_NAME"] = "middleName";
    CustomerDetailsFieldName["FIRST_NAME"] = "firstName";
    CustomerDetailsFieldName["LAST_NAME"] = "lastName";
    CustomerDetailsFieldName["ADDRESS"] = "address";
})(CustomerDetailsFieldName || (CustomerDetailsFieldName = {}));
export const phoneFieldCountriesOrder = {
    nl: ['NL', 'BE', 'DE', '|'],
    gb: ['GB', 'IE', '|'],
    ie: ['IE', 'GB', '|'],
    lu: ['LU', '|'],
    fr: ['FR', '|'],
    be: ['BE', '|'],
};
export const getCustomerDetailsValidationSchema = ({ t, prefix }) => {
    const [idTitle, firstName, lastName, middleName] = mapWithAssert([
        CustomerDetailsFieldName.ID_TITLE,
        CustomerDetailsFieldName.FIRST_NAME,
        CustomerDetailsFieldName.LAST_NAME,
        CustomerDetailsFieldName.MIDDLE_NAME,
    ], name => generateFieldName(name, prefix));
    const defaultRequiredMessage = t(ErrorMessage.ACCOUNT_REQUIRED);
    return Yup.object({
        [idTitle]: Yup.number()
            .required(defaultRequiredMessage)
            .test('isEmptyTitle', defaultRequiredMessage, value => value !== -1),
        [firstName]: Yup.string().required(defaultRequiredMessage),
        [lastName]: Yup.string().required(defaultRequiredMessage),
        [middleName]: Yup.string(),
    });
};
export const getPhoneNumbersValidationSchema = ({ t, shouldValidate }) => Yup.object({
    phoneNumber: Yup.string()
        .test('isPossiblePhoneNumber', t(ErrorMessage.INVALID_PHONE), val => !val || isPossiblePhoneNumber(val))
        .when('shouldValidate', {
        is: true,
        then: schema => schema,
        otherwise: schema => schema.strip(),
    }),
    savePhoneNumber: Yup.boolean(),
}).transform(value => (Object.assign(Object.assign({}, value), { shouldValidate })));
